//COVID19
export const COVID_19 = 'COVID_19';
export const CONTACT_COVID19 = 'CONTACT_COVID19';
export const CLEAN_RESULT_COVID = 'CLEAN_RESULT_COVID'
//loading or error
export const ADD_ERROR = 'ADD_ERROR';
export const REMOVE_ERROR = 'REMOVE_ERROR';
export const REMOVE_OR_ACTIVE_LOADING = 'REMOVE_OR_ACTIVE_LOADING';